import type { ListItem } from '../../type/list';
import { Site, SLD } from '@patsnap-utils/biz';
const YUNCHUANG_URI = process.env.VUE_APP_YUNCHUANG_URI;
const INNOCLOUD_URI = process.env.VUE_APP_INNOCLOUD_URI;
const CAS_URI = process.env.VUE_APP_CAS_URI;

const fulllist_type_1: ListItem[] = [
    { key: 'workspace', icon: 'LogoWorkspace', label: 'PtHeader_products.workspace', href: new Site({ sld: SLD.WORKSPACE }).href },
    { key: 'analytics', icon: 'LogoAnalytics', label: 'PtHeader_products.analytics', href: new Site({ sld: SLD.ANALYTICS, pathname: 'search/input' }).href },
    { key: 'insights', icon: 'LogoInsigths', label: 'PtHeader_products.insights', href: new Site({ sld: SLD.INSIGHTS }).href },
    { key: 'discovery', icon: 'LogoDiscovery', label: 'PtHeader_products.discovery' },
    { key: 'bio', icon: 'LogoBio', label: 'PtHeader_products.bio', href: new Site({ sld: SLD.BIO }).href },
    { key: 'synapse', icon: 'LogoSynapse', label: 'PtHeader_products.synapse', href: new Site({ sld: SLD.SYNAPSE }).href },
    { key: 'chemical', icon: 'LogoChemical', label: 'PtHeader_products.chemical', href: new Site({ sld: SLD.CHEMICAL }).href },
    { key: 'cas', icon: 'LogoCas', label: 'PtHeader_products.cas', href: CAS_URI },
    { key: 'innosnap', icon: 'LogoIpManagement', label: 'PtHeader_products.ipAsset', href: new Site({ sld: SLD.INNOSNAP }).href },
    { key: 'academy', icon: 'LogoAcademy', label: 'PtHeader_products.academy', href: new Site({ sld: SLD.ACADEMY }).href },
    { key: 'course', icon: 'LogoCourseToC', label: 'PtHeader_products.course', href: new Site({ sld: SLD.COURSE_2C }).href },
    { key: 'course2b', icon: 'LogoCourseToB', label: 'PtHeader_products.course2b', href: new Site({ sld: SLD.COURSE_2B }).href },
    { key: 'lab', icon: 'LogoLab', label: 'PtHeader_products.lab', href: new Site({ sld: SLD.LAB }).href },
    { key: 'openapi', icon: 'LogoOpen', label: 'PtHeader_products.open', href: new Site({ sld: SLD.OPEN }).href },
    { key: 'tffi', icon: 'LogoTffi', label: 'PtHeader_products.tffi', href: new Site({ sld: SLD.TFFI }).href },
    { key: 'eureka', icon: 'LogoEureka', label: 'PtHeader_products.eureka', href: new Site({ sld: SLD.EUREKA }).href },
    { key: 'marketplace', icon: 'LogoMarketPlace', label: 'PtHeader_products.marketPlace', href: new Site({ sld: SLD.ANALYTICS, pathname: 'marketplace/' }).href },
    { key: 'yunchuang', icon: 'LogoYunChuang', label: 'PtHeader_products.yunchuang', href: YUNCHUANG_URI },
    { key: 'innocloud', icon: 'LogoInnoCloud', label: 'PtHeader_products.innoCloud', href: `${INNOCLOUD_URI}/innoe-web/jump2cloud` },
    // 测试专门要的测试产品
    { key: 'fabric', icon: 'LogoFabric', label: 'Fabric', href: '' }
];

export const getFullListType1 = (): ListItem[] => {
    return fulllist_type_1;
};
